export default __webpack_public_path__ + "static/media/TSP.7780a970.png";